/* eslint-disable indent */
import TableView from '@/components/clients/TableView';
import ClientForm from '@/components/forms/clientForm/ClientForm';
import { Command, CommandInput } from '@/components/shadcn/ui/command';
import { toast } from '@/components/shadcn/ui/use-toast';
import { ClientProvider, useClientContext } from '@/context/ClientContext';
import { IndicatorProvider } from '@/context/IndicatorContex';
import { UpdateClient, UpdateClientStatusDto } from '@/entities/clients';
import { useClients } from '@/hook/useClients';
import PhoneMaskUtils from '@/utils/PhoneMaskUtils';
import MaskRemover from '@/utils/removeMask';
import { useEffect, useState } from 'react';
import React from 'react';

interface Contact{
  idContato: number;
  nomeContato: string;
  celular: string;
  clientId: number;
  fixo: string;
  email: string;
  funcao: string;
}

interface ClientFormData {
  id: number
  nomefantasia: string;
  razao: string;
  ramo: string;
  status: string;
  responsible: string;
  cpfOrCnpj: string;
  //contato
  contatos: Contact[];
  //endereco
  addressId: number;
  cep: string;
  rua: string;
  cidade: string;
  uf: string;
  bairro: string;
  numero: string;
}

const ClientPage = () => {
  
  const {clientsUse, contatos, setContatos, createClient, create,  deleteCascadeCliente, updateCliente, deleteAllContact, updateClientStatus, fetchClientList, searchClients, foundedClients} = useClients();
  const { alterStatus, setAlterStatus } = useClientContext();
  const companyId = Number(localStorage.getItem("companyId"));
  const [clients, setClient] = useState<ClientFormData[]>([
    // {
    //   cpfOrCnpj: '111.111.111-60',
    //   nomefantasia: 'Empresa Abc',
    //   razao: 'Abc ltda',
    //   ramo: 'Comércio',
    //   status: 'Ativo',
    //   contatos: [{
    //     idContato: 1, 
    //     nomeContato: 'Maria',
    //     celular: '98888-8888',
    //     fixo: '98888-9999',
    //     email: 'maria@yahoo.com',
    //     funcao: 'Sócia',
    //   }],
    //   cep: '65400-590',
    //   rua: 'Rua Marechal',
    //   cidade: 'Teresina',
    //   uf: 'PI',
    //   bairro: 'Porto Alegre',
    //   numero: '1111',
    // }
  ]);
  const [ open, setOpen ] = useState(false);

  useEffect(() => {
  
    const clientes = clientsUse.map((c) => ({
      id: c.id,
      nomefantasia: c.fantasyName,
      razao: c.corporateName,
      responsible: c.responsible,
      ramo: c.activityBranch,
      status: c.status === 'A' ? 'Ativo' : 'Inativo',
      cpfOrCnpj: c.cpfCnpj,
      // contatos
      contatos: Array.isArray(c.contacts) ? c.contacts.map((co) => ({
        idContato: co.id,
        nomeContato: co.name,
        celular: co.phone,
        clientId: co.clientId,
        fixo: co.phone,
        email: co.email,
        funcao: co.function,
      })) : [],
      // endereço
      addressId: c.address?.id,
      cep: c.address?.zipCode,
      rua: c.address?.address,
      cidade: c.address?.city,
      uf: c.address?.federativeUnit,
      bairro: c.address?.neighborhood,
      numero: c.address?.number,
    }));
  
    setClient(clientes);
  }, [clientsUse]);
  

  const handleStatusChange = (index: number, id: number, currentStatus: string) => {
    const newStatus = currentStatus === 'Ativo' ? 'I' : 'A';
    const client = {
      status: newStatus,
    };
    clients[index].status = newStatus === 'A' ? 'Ativo' : 'Inativo';
    setAlterStatus(!alterStatus);
    onClientStatusUpdate(id, client);
  };

  const handleClientSubmit = async (data: any) => {
    const data2: any = {
      id: data.id,
      cpfCnpj: MaskRemover.removeMask(data.cpfOrCnpj),
      fantasyName: data.nomefantasia,
      corporateName: data.razao,
      responsible: data.responsible,
      activityBranchId: Number(data.activityBranchId),
      companyId: companyId,
      status: data.status === 'Ativo' ? 'A' : 'I',
    };
  
    // Se houver contato, adiciona ao objeto
    if (data.contatos && data.contatos.length > 0) {
      data2.contact = {
        name: data.contatos[0].nomeContato,
        cellPhone: PhoneMaskUtils.unformat(data.contatos[0].celular),
        phone: PhoneMaskUtils.unformat(data.contatos[0].fixo),
        email: data.contatos[0].email,
        function: data.contatos[0].funcao,
      };
    }
  
    // Se houver endereço, adiciona ao objeto
    if (data.cep && data.rua && data.cidade && data.uf && data.bairro && data.numero) {
      data2.address = {
        zipCode: data.cep.includes('-') ? data.cep.replace('-', '') : data.cep,
        address: data.rua,
        city: data.cidade,
        federativeUnit: data.uf,
        neighborhood: data.bairro,
        number: data.numero,
      };
      const created = await create(data2);
    if (created) {
      data.id = created.id;
      toast({description: 'Cliente Cadastrado com sucesso'});
    }
    } else {
      const created = await createClient(data2);
      if (created) {
        data.id = created.id;
        toast({description: 'Cliente Cadastrado com sucesso'});
      }
    }
    setClient([...clients, data]);
  };
  

  // const handleStatusChange = (index: number, id: number, currentStatus: string) => {
  //   const newStatus = currentStatus === 'Ativo' ? 'I' : 'A';
  //   const client = {
  //     status: newStatus,
  //   };
  //   setAlterStatus(!alterStatus);
  //   updateClientStatus(id, client);
  // };

  const handleClientUpdate = (index: number, data:any) =>{
    const data2 = {
      id: data.id,
      cpfCnpj: data.cpfOrCnpj.includes('-') & data.cpfOrCnpj.includes('.') ? MaskRemover.removeMask(data.cpfOrCnpj) : data.cpfOrCnpj,
      fantasyName: data.nomefantasia,
      corporateName: data.razao,
      responsible: data.responsible,
      activityBranchId: data.activityBranchId,
      status: data.status === 'Ativo' ? 'A': 'I',
      address:{
        zipCode: data.cep.replace('-', ''),
        address: data.rua,
        city: data.cidade,
        federativeUnit: data.uf,
        neighborhood: data.bairro,
        number: data.numero
      }  
    };

    clients[index].cpfOrCnpj = data2.cpfCnpj;
    clients[index].nomefantasia = data2.fantasyName;
    clients[index].ramo = data.ramo;
    clients[index].responsible = data.responsible;
    clients[index].status = data2.status === 'A' ? 'Ativo' : 'Inativo';
    clients[index].razao = data2.corporateName;
    clients[index].cep = data2.address.zipCode;
    clients[index].rua = data2.address.address;
    clients[index].cidade = data2.address.city;
    clients[index].uf = data2.address.federativeUnit;
    clients[index].bairro = data2.address.neighborhood;
    clients[index].numero = data2.address.number; 
    updateCliente(data2);

  };

  const editOrCreateClient = (index:number | undefined, data:any) => {
    if(index !== undefined){
      handleClientUpdate(index, data);
    }else{
      handleClientSubmit(data);
    }
  };

  const onClientStatusUpdate = async (index:number, client:UpdateClientStatusDto) =>{
    updateClientStatus(index, client);
  };
  
  return (
    
      <div className='min-h-screen bg-indigo-200 p-8'>
          <div className='min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4 '>   
            <div className='flex m-2 justify-between items-center pr-2'>
              <h1 className='m-4 text-md font-medium'>Clientes</h1>
              <div className='flex gap-6'>
                <ClientForm onClientSubmit={editOrCreateClient}/>
                <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
                  <CommandInput
                  onChangeCapture={(e) => { 
                    const target = e.target as HTMLInputElement;
                    if(target.value!=''){
                      searchClients(target.value);
                      setClient(foundedClients.map((c)=>({
                        id: c.id,
                        nomefantasia: c.fantasyName,
                        razao: c.corporateName,
                        responsible: c.responsible,
                        ramo: c.activityBranch,
                        status: c.status === 'A' ? 'Ativo' : 'Inativo',
                        cpfOrCnpj: c.cpfCnpj,
                        //contato
                        contatos: c.contacts.length > 0 ? c.contacts.map((co)=>({
                          idContato: co.id,
                          nomeContato: co.name,
                          celular: co.phone,
                          clientId: co.clientId,
                          fixo: co.phone,
                          email: co.email,
                          funcao: co.function
                        })) : [],
                        //endereco
                        addressId: c.address.id,
                        cep: c.address.zipCode,
                        rua: c.address.address,
                        cidade: c.address.city,
                        uf: c.address.federativeUnit,
                        bairro: c.address.neighborhood,
                        numero: c.address.number,
                      })));
                    } else if(target.value === '' || foundedClients.length === 0){
                      setClient(clientsUse.map((c)=>({
                        id: c.id,
                        nomefantasia: c.fantasyName,
                        razao: c.corporateName,
                        ramo: c.activityBranch,
                        responsible: c.responsible,
                        status: c.status === 'A' ? 'Ativo' : 'Inativo',
                        cpfOrCnpj: c.cpfCnpj,
                        //contato
                        contatos: c.contacts.length > 0 ? c.contacts.map((co)=>({
                          idContato: co.id,
                          nomeContato: co.name,
                          celular: co.phone,
                          clientId: co.clientId,
                          fixo: co.phone,
                          email: co.email,
                          funcao: co.function
                        })) : [],
                        //endereco
                        addressId: c.address.id,
                        cep: c.address.zipCode,
                        rua: c.address.address,
                        cidade: c.address.city,
                        uf: c.address.federativeUnit,
                        bairro: c.address.neighborhood,
                        numero: c.address.number,
                      })));
                    }
                  }}
                  placeholder="Pesquisar..."/>
                </Command>
              </div>
            </div>
            <div>
            <TableView
            data={clients}
            onClientStatusUpdate={handleStatusChange} 
            />
            </div>
          </div>
        </div>
      
  );
};

export default ClientPage;
